
<script>
import { rexTextarea } from '@/components/views/rexField'

export default {
  name: 'AgencyForm',
  components: {
    rexTextarea
  },
  computed: {
    agencyFormIsShown() {
      return this.$store.getters['myAgency/showAgencyForm']
    },
    agencyProfile() {
      return this.$store.getters['profile/getAgencyProfile']
    },
    agencyForm() {
      return this.$store.getters['myAgency/getAgencyForm']
    },
  },
  methods: {
    showAgencyForm() {
      this.$store.commit('myAgency/changeShowAgencyForm', true)
    },
    hideAgencyForm() {
      this.$store.commit('myAgency/changeShowAgencyForm', false)
    },
    submitAgencyForm(data) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('myAgency/updateAgencyProfile', this.agencyForm)
        }
      })
    },
  }
}
</script>

<template>
  <div class="my-agency__agency-info">
    <div
      v-if="!agencyFormIsShown"
    >
      <p>
        Если вам необходимо внести изменения в данные о компании,
        отправьте нам заявку на внесение изменений.
      </p>
      <a
        href="javascript:;"
        class="rex-btn rex-btn--bold"
        @click="showAgencyForm"
      >
        <span>Отправить заявку</span>
      </a>
    </div>
    <div
      v-if="agencyFormIsShown"
      class="my-agency__agency-form"
    >
      <form @submit.prevent="submitAgencyForm">
        <rex-textarea
          name="message"
          store-module="myAgency"
          getter-name="getField"
          setter-name="updateField"
          target="agencyForm.message"
          :show-label="false"
          placeholder="Введите Сообщение"
          :validate="{
            required: true
          }"
        />
        <button
          class="my-agency__btn rex-btn rex-btn--bold"
        >
          <span>Отправить</span>
        </button><br>
        <a
          href="javascript:;"
          class="my-agency__btn rex-btn rex-btn--bold rex-btn--gray"
          @click="hideAgencyForm"
        >
          <span>Закрыть без изменений</span>
        </a>
      </form>
    </div>
  </div>
</template>